import { useState, useCallback } from 'react';

interface UseSaveFileModalReturn {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  handleSave: (callback: (filePath: string) => Promise<void>) => (filePath: string) => void;
}

/**
 * ファイル保存モーダルの状態管理フック
 */
export function useSaveFileModal(): UseSaveFileModalReturn {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleSave = useCallback((callback: (filePath: string) => Promise<void>) => {
    return (filePath: string) => {
      callback(filePath);
      closeModal();
    };
  }, [closeModal]);

  return {
    isOpen,
    openModal,
    closeModal,
    handleSave
  };
}